/** Типи зв'язків платформи з оберненими (прототип v4 LINK_TYPES; core.link.link_type): «Блокує» ↔ «Заблоковано» тощо. */
export const linkTypeInverse: Record<string, string> = {
  relates: 'relates', blocks: 'blocked', blocked: 'blocks', parent: 'child', child: 'parent',
  duplicates: 'duplicated', duplicated: 'duplicates', follows: 'followed', followed: 'follows',
};
